module.exports = __webpack_public_path__ + "img/m12.51f71bbd.jpg";